var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6476 10.0741L20.3226 13.7391M9.15845 23.7083H22.8418M9.45345 19.9458L9.86428 17.0916C9.88638 16.9052 9.97271 16.7322 10.1084 16.6025L18.1626 8.54913C18.2662 8.44357 18.3952 8.36654 18.5373 8.32551C18.6793 8.28448 18.8296 8.28085 18.9734 8.31497C19.7165 8.51223 20.3922 8.90737 20.9284 9.4583C21.483 9.99335 21.8817 10.6691 22.0818 11.4133C22.1126 11.5573 22.1073 11.7068 22.0663 11.8483C22.0253 11.9898 21.9499 12.1189 21.8468 12.2241L13.7934 20.2775C13.6546 20.4057 13.4815 20.4908 13.2951 20.5225L10.4309 20.9325C10.2975 20.9505 10.1618 20.9373 10.0343 20.8939C9.90685 20.8506 9.7912 20.7782 9.69645 20.6826C9.6017 20.587 9.53043 20.4706 9.48827 20.3428C9.4461 20.2149 9.43418 20.079 9.45345 19.9458Z",
    stroke: "#E2209E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.66e5b4aaf2c89acf63d4e6abb0a86902.svg";
export { ForwardRef as ReactComponent };